import { Components, sliderClasses, Theme } from '@mui/material';

const SLIDER_THUMB_SHADOW =
  '0px 2px 5px rgba(31, 34, 38, 0.2), 0px 3px 15px rgba(31, 34, 38, 0.2)';

export function getMuiSlider(theme: Theme): Components['MuiSlider'] {
  return {
    styleOverrides: {
      root: {
        height: 8,
        [`&.${sliderClasses.disabled} .${sliderClasses.markLabel}`]: {
          color: theme.palette.grey[400],
        },

        [`&.showValue .${sliderClasses.thumb}`]: {
          border: '4px solid',
        },
      },

      valueLabel: {
        fontSize: 14,
        fontWeight: 400,
        color: theme.palette.grey[900],
        backgroundColor: theme.palette.background.paper,
        padding: '6px 12px',
        height: 32,
        borderRadius: theme.shape.borderRadiusMd, // ex 11,
        boxShadow:
          '0px 2px 5px rgba(31, 34, 38, 0.1), 0px 3px 15px rgba(31, 34, 38, 0.1)',
        top: -8,
        '&:before': {
          display: 'none',
        },
      },

      mark: {
        display: 'none',
      },

      markLabel: {
        fontSize: 14,
        color: theme.palette.grey[800],
        top: 34,
      },

      rail: {
        height: 4,
        borderRadius: 2,
        opacity: 1,
        backgroundColor: theme.palette.grey[100],
      },

      track: {
        height: 8,
        borderRadius: theme.shape.borderRadiusXs,
      },

      thumb: {
        width: 28,
        height: 28,
        marginTop: 0,
        marginLeft: 0,
        backgroundColor: theme.palette.background.paper,
        boxShadow: SLIDER_THUMB_SHADOW,

        [`&.${sliderClasses.focusVisible}, &.${sliderClasses.active}, &:hover`]:
          {
            boxShadow: SLIDER_THUMB_SHADOW,
            border: `4px solid ${theme.palette.primary.main}`,
          },

        [`&&.${sliderClasses.focusVisible}, &&:hover`]: {
          '@media (hover: none)': {
            boxShadow: SLIDER_THUMB_SHADOW,
            border: `4px solid ${theme.palette.primary.main}`,
          },
        },

        [`&.${sliderClasses.disabled}`]: {
          backgroundColor: theme.palette.grey[400],
          boxShadow: 'none',
        },
      },
    },
  };
}
